export type CMIElement = string;
export type CMIBoolean = 'true' | 'false';

export interface Scorm2004Api {
  Initialize(param: ''): CMIBoolean;
  Terminate(param: ''): CMIBoolean;
  GetValue( element: CMIElement ): string;
  SetValue( element: CMIElement, value: string): string;
  Commit( param: '' ): CMIBoolean;
  GetLastError(): CMIErrorCode;
  GetErrorString( errorCode: CMIErrorCode ): string;
  GetDiagnostic( errorCode: CMIErrorCode ): string;
}

export enum CMIErrorCode {
  noError = '0',
  generalException = '101',
  generalInitializationFailure = '102',
  alreadyInitialized = '103',
  contentInstanceTerminated = '104',
  generalTerminationFailure = '111',
  terminationBeforeInitialization = '112',
  terminationAfterTermination = '113',
  retrieveDataBeforeInitialization = '122',
  retrieveDataAfterTermination = '123',
  storeDataBeforeInitialization = '132',
  storeDataAfterTermination = '133',
  commitBeforeInitialization = '142',
  commitAfterTermination = '143',
  generalArgumentError = '201',
  generalGetFailure = '301',
  generalSetFailure = '351',
  generalCommitFailure = '391',
  undefinedDataModelElement = '401',
  unimplementedDataModelElement = '402',
  dataModelElementValueNotInitialized = '403',
  dataModelElementIsReadOnly = '404',
  dataModelElementIsWriteOnly = '405',
  dataModelElementTypeMismatch = '406',
  dataModelElementValueOutOfRange = '407',
  dataModelDependencyNotEstablished = '408'
}
